import React from 'react';
import { useIntl } from 'react-intl';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { AuthenticationTabs, PlatformsList } from '../../../components';
import { HeaderTitle } from '../../../components/ui';
import { RouteParams } from '../../../routes/types';

const PlatformSettings = ({ match }: RouteComponentProps): JSX.Element => {
  const { projectId } = match.params as RouteParams;
  const intl = useIntl();

  return (
    <AuthenticationTabs>
      <HeaderTitle
        title={intl.formatMessage({ id: 'settings.tabs.platform-settings' })}
        subtitle={intl.formatMessage({ id: 'social-connection.subtitle' })}
      />
      <PlatformsList projectId={projectId} />
    </AuthenticationTabs>
  );
};

export default withRouter(PlatformSettings);
